/** 授课数据相关 */
import {get, post, postByJson, E_URL } from './https.js';

export default {
    /** 授课首页部分 */
    // 未授课的教学设计列表
    pagingNotGivedTd(param) {
        return get(E_URL + 'e0001/paging/not/gived/td', param);
    },
    // 已授课的教学设计列表
    pagingGivedTd(param) {
        return get(E_URL + 'e0001/paging/gived/td', param);
    },
    // 已授课的教学设计列表
    createGivingData(param) {
        return post(E_URL + 'e0001/create/giving', param);
    },

    /** 授课部分 */
    // 获取授课的PPT内容
    infoPPT(param) {
        return get(E_URL + 'e0002/info/ppt', param);
    },
    // 获取授课的学生列表
    listGlStus(param) { return get(E_URL + 'e0002/list/stu', param); },
    // 获取授课的小组列表
    listGlTeams(param) {
        return get(E_URL + 'e0002/list/team', param);
    },
    //学生加星情况
    getStudentStar(param) {
        return get(E_URL + 'e0002/student/getStudentStar', param);
    },
    // 给学生加星
    addStuStar(param) {
        return post(E_URL + 'e0002/student/star', param);
    },
    // 小组加星
    addTeamStar(param) { return post(E_URL + 'e0002/team/star', param); },
    // 小组加星(根据授课Id，小组ID为小组加星)
    addTeamStarByTeamId(param) { return post(E_URL + 'e0002/team/star/teamid', param); },

    // 学生资源展示
    listGLStusResource(param){
        return post(E_URL + 'e0002/list/student/resource', param);
    },
    // 小组资源展示
    listGLTeamResource(param){
        return postByJson(E_URL + 'e0002/list/team/resource', param);
    },

    // 随机点名，向授课学生互动关联表中插入数据
    rollCall(param) {
        return post(E_URL + 'e0002/student/rollCall', param);
    },
    // 手动考勤签到
    finishAttendance(param) {
        return postByJson(E_URL + 'e0002/student/finishAttendance', param);
    },
    // 重新考勤
    signInAgain(param) {
        return postByJson(E_URL + 'e0002/signInAgain', param);
    },
    // 自动考勤完成
    autoAttendComplete(param) {
        return post(E_URL + 'e0002/student/autoAttend/complete', param);
    },
    // 发送
    sendResource(param) {
        return postByJson(E_URL + 'e0002/send/resource', param);
    },
    // 任务发送前对小组人数的验证
    checkForSendTask(param) {
        return get(E_URL + 'e0002/send/task/check', param);
    },
    // 获取聊天内容
    getChatArr(param) { return get(E_URL + 'e0003/chat', param); },
    // 获取全班讨论内容
    getClassChatArr(param) { return get(E_URL + 'e0003/classChat', param); },
    // 授课考勤
    addAttendance(param) {
        return postByJson(E_URL + 'e0002/attendance', param);
    },

    getAttendanceDetails(param){
        return get(E_URL + 'e0002/attendanceDetail', param);
    },
    // 考勤明细
    addAttendanceDetail(param) {
        return postByJson(E_URL + 'e0002/attendanceDetail', param);
    },
    // 添加授课下的所有学生到考勤明细
    addAttendanceDetailByGl(param){
        return postByJson(E_URL + 'e0002/addAttendanceDetailByGl', param);
    },
    //查询分组下的学生信息
    selectFenZuStudentInfo(param) {
      return get(E_URL + 'e0002/selectFenZuStudentInfo', param);
    },

    // 查询授课班级学生信息
    selectClassStudentInfo(param){
      return get(E_URL + 'e0002/selectClassStudentInfo', param);
    },

    // 查看学生游戏分数
    getGameGrade(param){
        return get(E_URL + 'e0002/getGameGrade', param);
    },
    getGameResult(param) {
        return get(E_URL + 'e0002/getGameResult', param);
    },
    // 查看学生数
    getStudent(param){
        return get(E_URL + 'e0002/getStudent', param);
    },
    // 初始化未授课的教学设计
    notGivedTd(param){
        return get(E_URL + 'e0001/notGivedTd', param);
    },
    // 初始化授课的教学设计
    givedTd(param){
        return get(E_URL + 'e0001/givedTd', param);
    },
    // 初始化授课的教学设计已经结束
    givedTdOver(param){
        return get(E_URL + 'e0001/givedTdOver', param);
    },
    // 课堂数据
    historyCourseData(param) {
        return get(E_URL + 'e0002/historyCourseData',param);
    },
    // 记录老师暂停授课时间和结束授课时间
    giveLessonsTime(param) {
        return get(E_URL + 'e0002/giveLessonsTime', param);
    },
    // 记录老师当前ppt页码
    recordPptPage(param) {
        return get(E_URL + 'e0002/recordPptPage', param);
    },
    createGiveLessonsTime(param) {
        return get(E_URL + 'e0002/createGiveLessonsTime', param)
    },
    getRate(param) {
        return get(E_URL + 'e0002/getRate', param)
    },
    // 获取该学生该题的答案
    getStudentExerAnswer(param) {
        return get(E_URL + 'e0002/getStudentExerAnswer', param)
    },
    // 获取该学生该题的答案(填空)
    getStudentExerAnswerByFill(param) {
        return get(E_URL + 'e0002/getStudentExerAnswerByFill', param)
    },
    // 获取该学生该题的答案(简答,计算)
    getStudentExerBriefAndCalculateAnswer(param) {
        return get(E_URL + 'e0002/getStudentExerBriefAndCalculateAnswer', param)
    },
    // 获取该学生该题的答案(分录)
    getStudentExerAnswerByAccount(param) {
        return get(E_URL + 'e0002/getStudentExerAnswerByAccount', param)
    },
    // 获取该学生该题的答案(分录)
    getStudentExerAnswerByAccountGroup(param) {
        return get(E_URL + 'e0002/getStudentExerAnswerByAccountGroup', param)
    },
    // 获取该学生该题的答案(表格)
    getStudentExerAnswerByTable(param) {
        return get(E_URL + 'e0002/getStudentExerAnswerByTable', param)
    },
    // 获取该学生该题的答案(表格)
    getStudentExerAnswerByTableNew(param) {
        return get(E_URL + 'e0002/getStudentExerAnswerByTableNew', param)
    },
    // 获取该学生该题的答案(表格)(一个空学生答题情况)
    getStudentExerAnswerByTableAllStu(param) {
        return get(E_URL + 'e0002/getStudentExerAnswerByTableAllStu', param)
    },
    // 查询授课下学生信息
    getStudentScoreInfoDto(param) {
      return get(E_URL + 'e0002/getStudentScoreInfoDto', param)
    },
   // 查询授课下学生课堂表现
  getClassroomInteraction(param) {
    return get(E_URL + 'e0002/getClassroomInteraction', param)
  }
}



// WEBPACK FOOTER //
// ./src/components/tools/request/https-e.js